"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Play = void 0;
var react_1 = __importDefault(require("react"));
var constants_1 = require("../constants");
var colors_1 = require("../../colors");
var Play = function (_a) {
    var color = _a.color, height = _a.height, size = _a.size, width = _a.width;
    return (react_1.default.createElement("svg", { width: width || size || constants_1.DEFAULT_ICON_SIZE, height: height || size || constants_1.DEFAULT_ICON_SIZE, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M19 10.9282C20.3333 11.698 20.3333 13.6225 19 14.3923L10 19.5885C8.66667 20.3583 7 19.396 7 17.8564L7 7.4641C7 5.9245 8.66667 4.96225 10 5.73205L19 10.9282Z', fill: color ? (0, colors_1.getColor)(color) : 'currentColor' })));
};
exports.Play = Play;
